/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Text } from 'grommet'
import { Card } from 'grommet-controls'
import { Group } from 'grommet-icons'
import CountUp from 'react-countup';
import { format } from '../utils/utils'

class CardMembers extends React.Component {
  
  render() {
    console.log('Nombre de membres : ', this.props.members)
    let message;
    if (this.props.static) {
      message = format(this.props.members)
    }
    else {
      message = (
        <CountUp
          start={0} 
          end={this.props.members}
          duration={10}
          delay={0}
          redraw={true}
        >
          {({ countUpRef }) => (
            <div>
              <span ref={countUpRef} />
            </div>
          )}
        </CountUp>
      )
    }
    return(
      <Card
        background='brand'
        basis='small'
        size={{ width: 'small', height: 'small' }}
      >         
        <Card.CardTitle align='center'>
          <Group color='text' size='3em'/>
          <Text size='xlarge'>Membres</Text>
        </Card.CardTitle>
        <Card.CardContent align='center'>
          <Text size='xxlarge'>
            { message }
          </Text>
        </Card.CardContent>
      </Card>
    )
  }
}

export default CardMembers
